export const UserRolesRepositoryToken = Symbol('UserRolesRepository');
export const SubscriptionRepositoryToken = Symbol('SubscriptionRepository');
export const CSModeRepositoryToken = Symbol('CSModeRepository');
export const FacilityIdRepositoryToken = Symbol('FacilityIdRepository');
export const FacilityRepositoryToken = Symbol('FacilityRepositoryToken');
